export enum FavoriteViewFormSteps {
  INFORMATION = 'INFORMATION',
  FILTERS = 'FILTERS',
  GRID = 'GRID',
  REPORT = 'REPORT',
  SUBSCRIBERS = 'SUBSCRIBERS'
}

export enum FavoriteViewFormControlNames {
  NAME = 'name',
  BUSINESS_PROFILE = 'businessProfile',
  COLOR = 'color',
  GRID = 'grid',
  FILTERS = 'filters',
  DESCRIPTION = 'description',
  PINNED = 'pinned',
  SHARED = 'shared'
}
